export const DEFAULT_VALUE = 0

export interface EnumOption {
  value: number
  label: string
}

/** Build EnumOption[] from a Record<number, string> translation map. */
export function buildEnumOptions(map: Record<number, string>): EnumOption[] {
  return Object.entries(map).map(([key, label]) => ({ value: Number(key), label }))
}
